export default __webpack_public_path__ + "static/media/settings.78a3e67b.svg";